import { Datagrid, FunctionField, List, SelectInput, TextField } from 'react-admin';
import { UserLink } from '../../components/EntityLink';
import { StatusChip } from '../../components/StatusChip';
import { HideInvitationButton } from './InvitationActions';
import {
  formatDateTime,
  invitationCategoryLabels,
  invitationStatusLabels,
  label,
  paymentTypeLabels,
} from '../../i18n/labels';

const filters = [
  <SelectInput
    key="status"
    source="status"
    label="Статус"
    choices={[
      { id: 'active', name: 'Активно' },
      { id: 'archived', name: 'В архиве' },
      { id: 'cancelled', name: 'Отменено' },
      { id: 'all', name: 'Все' },
    ]}
    alwaysOn
  />,
];

export function InvitationsList(): JSX.Element {
  return (
    <List
      filters={filters}
      filterDefaultValues={{ status: 'active' }}
      perPage={50}
      pagination={false}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <FunctionField
          label="Категория"
          render={(record: { category: string }) =>
            label(invitationCategoryLabels, record.category)
          }
        />
        <TextField source="place.name" label="Место" />
        <FunctionField
          label="Автор"
          render={(record: { author: { id: string; displayName: string | null } }) => (
            <UserLink id={record.author.id} label={record.author.displayName} />
          )}
        />
        <FunctionField
          label="Оплата"
          render={(record: { paymentType: string }) => label(paymentTypeLabels, record.paymentType)}
        />
        <FunctionField
          label="Когда"
          render={(record: { scheduledAt: string }) => formatDateTime(record.scheduledAt)}
        />
        <TextField source="description" label="Описание" />
        <FunctionField
          label="Статус"
          render={(record: { status: string }) => (
            <StatusChip status={record.status} dict={invitationStatusLabels} />
          )}
        />
        <HideInvitationButton />
      </Datagrid>
    </List>
  );
}
